module.exports = __webpack_public_path__ + "static/media/32.324bce9c.jpg";